import { SEVERITY, type SeverityKey } from '../../../patient-files/notes/severity';

const SEVERITY_KEYS: SeverityKey[] = ['info', 'warning', 'critical'];

interface AddPatientNoteSeverityToggleProps {
    value: SeverityKey;
    onChange: (severity: SeverityKey) => void;
    /** Associates the group with the "Severity" section label above it. */
    labelId: string;
}

/** The standard Info/Warning/Critical toggle (see patient-files' NoteModal).
 *  `aria-pressed` carries the selected state to AT - color alone doesn't. */
export function AddPatientNoteSeverityToggle({
    value,
    onChange,
    labelId
}: AddPatientNoteSeverityToggleProps) {
    return (
        <div role="group" aria-labelledby={labelId} className="flex gap-2">
            {SEVERITY_KEYS.map((key) => {
                const s = SEVERITY[key];
                const Icon = s.icon;
                const active = value === key;
                return (
                    <button
                        key={key}
                        type="button"
                        aria-pressed={active}
                        onClick={() => onChange(key)}
                        className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-xl border-2 transition-all ${
                            active
                                ? `${s.border} ${s.bg} ${s.iconColor} ring-2 ${s.ring}`
                                : 'border-gray-200 bg-white text-gray-400 hover:border-gray-300'
                        }`}
                    >
                        <span className={active ? s.iconColor : 'text-gray-400'}>
                            <Icon className="w-4 h-4" />
                        </span>
                        <span
                            className={`text-[12px] font-semibold ${
                                active ? s.iconColor : 'text-gray-500'
                            }`}
                        >
                            {s.label}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
